// extracted by mini-css-extract-plugin
export var label = "_io-2";
export var slideContainer = "_io-0";
export var slider = "_io-1";